const yourRequestsPage = {
  loading: "Loading your requests…",
  header: {
    title: "Your requests",
    subtitle: "Access and data requests you've submitted, across all projects",
    newRequest: "New request",
  },
  errors: {
    loadFailed: "Failed to load your requests",
    downloadFailed: "Failed to download data file.",
  },
  empty: {
    noRequests: "You haven't submitted any requests yet.",
    noMatches: "No requests match these filters.",
  },
  filters: {
    requesterMine: "My requests",
    requesterAll: "My projects' requests",
    allProjects: "All projects",
    allStatuses: "All statuses",
    allTypes: "All types",
    typeAccess: "Dataset access request",
    typeData: "Data request",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortReviewed: "Last reviewed",
    sortStatus: "Status priority",
  },
  list: {
    dataRequestPill: "Data request",
    accessRequestPill: "Dataset access request",
  },
  detail: {
    dataRequestBadge: "Data request",
    accessRequestBadge: "Dataset access request",
    titleLabelData: "Dataset title",
    titleLabelAccess: "Request",
    submitted: "Submitted",
    reviewed: "Reviewed",
    awaitingReview: "Awaiting review",
    filesLabel: "Files",
    filesEmpty:
      "Not uploaded yet — files will appear here once the project admin or data supplier uploads them.",
    requestedFiles: "Requested files (1)",
    downloadData: "Download data",
    downloading: "Downloading…",
  },
};

export default yourRequestsPage;
